// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/always-grey.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Services.css */
.underline-gradient {
  position: relative;
  display: inline-block;
  padding-bottom: 25px;
}

.underline-gradient::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 1px;
  background: linear-gradient(to right, white, rgba(246, 146, 47, 0));
  border-radius: 1px;
  width: 100%;  /* this now matches only the text width */
}


.services-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background-color: #151515;
    color: #FFF;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  
  .services-container .heading {
    font-size: 40px;
    font-weight: 500;
    text-align: left;
    width: 80%;
    margin-top: 30px;
  }
  
  .services-container .divider {
    width: 80%;
    border-bottom: 1px solid #575555;
    text-align: center;
    margin-bottom: 60px;
  }

  .services-container .main-box .title {
font-size: 30px;
margin-top:10px;
text-align: center;
width: max-content;
  }
 .services-container .main-box .sub-title {
  font-size: 25px;
  margin-bottom: 10px;
  background: linear-gradient(90deg, #f6922f, #f44336); /* change colors as needed */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
  .services-container .main-box .inner-content{
display: flex;
align-items: center;
font-size: 20px;
margin-top: 50px;
line-height: 1.6;
width: 100%;
  }
  .services-container .main-box .inner-content .image{
width: 100px;
height: 100px;
margin-right: 30px;
  }
  .services-container .section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .services-container .section-title {
    border: 2px solid white;
    background: #262626;
    margin-bottom: 50px;
    width: fit-content;
    padding: 10px;
    border-radius: 8px;
    font-size: 24px;
    font-weight: 600;
  }
  
  .services-container .main {
    display: flex;
    flex-direction: column;
  }
  .services-container .service-item {
    display: flex;
    height: 315px;
    border-bottom: 2px solid #fff;
  }
  .services-container .service-item .first {
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    border-right: 2px solid #fff;
    padding: 20px;
  }

  .services-container .service-item .title {
      font-size: 30px;
      font-weight: 600;
      color: #f7941d;
    }
  
    .services-container .service-item .second {
      display: flex;
      flex-direction: column;
      width: 50%;
      align-items: flex-start;
      text-align: left;
      padding: 20px;
    }
    .services-container .service-item1 {
      display: flex;
      height: 200px;
      border-bottom: 2px solid #fff;
    }
    .services-container .service-item1 .first {
      display: flex;
      flex-direction: column;
      width: 50%;
      align-items: flex-start;
      text-align: left;
      border-right: 2px solid #fff;
      padding: 20px;
    }

    .services-container .service-item1 .title {
      font-size: 30px;
      font-weight: 600;
      color: #f7941d;
    }
  
    .services-container .service-item1 .second {
      display: flex;
      flex-direction: column;
      width: 50%;
      align-items: flex-start;
      text-align: left;
      padding: 20px;
    }
    
    .services-container .service-item2 {
      display: flex;
      height: 200px;
      margin-bottom: 20px;
    }
    .services-container .service-item2 .first {
      display: flex;
      flex-direction: column;
      width: 50%;
      align-items: flex-start;
      text-align: left;
      border-right: 2px solid #fff;
      padding: 20px;
    }
    .services-container .service-item2 .title {
      font-size: 30px;
      font-weight: 600;
      color: #f7941d;
    }
  
    .services-container .service-item2 .second {
      display: flex;
      flex-direction: column;
      width: 50%;
      align-items: flex-start;
      text-align: left;
      padding: 20px;
    }
    
    .services-container .section .first {
      display: flex;
      flex-direction: column;
      width: 50%;
      justify-content: flex-start;
      align-items: flex-start;
      text-align: left;
      border-right: 2px solid #fff;
      padding: 20px;
  }
  
  .services-container .section .second {
      display: flex;
      flex-direction: column;
      width: 50%;
      align-items: flex-start;
      text-align: left;
      padding: 20px;
  }
  .services-container .printing-services-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .services-container .printing-services-title {
      border: 2px solid white;
      background: #262626;
      margin-bottom: 50px;
      width: fit-content;
      padding: 10px;
      border-radius: 8px;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
  }
  
  .services-container .printing-services-item {
      display: flex;
      height: 300px;
      /* border-bottom: 2px solid #fff; */
  }
  .services-container .printing-services-item .title {
    font-size: 30px;
    font-weight:600;
    color: #f7941d;
  }
  .services-container .printing-services-item .first {
      display: flex;
      flex-direction: column;
      width: 50%;
      justify-content: flex-start;
      align-items: flex-start;
      text-align: left;
      border-right: 2px solid #fff;
      padding: 20px;
      
  }
  
  .services-container .printing-services-item .second {
      display: flex;
      flex-direction: column;
      width: 50%;
      align-items: flex-start;
      text-align: left;
      padding: 20px;
  }
  
  .services-container .carousel-container {
      margin-top: 60px;
      background: #151515;
      width: 80%;
      padding: 30px 0;
  }
  
  .services-container .carousel-container .title {
      font-size: 50px;
      color: #FFF;
  }
  
  .services-container .carousel-container .carousel-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;
      background: red;
  }
  
  .services-container .carousel-container .carousel-item .title {
      font-size: 18px;
      color: #FFF;
      background-color: #262626;
      padding: 20px;
  }
  
  .services-container .carousel-container .carousel-item .image-container {
      display: flex;
      justify-content: center;
      background-color: #262626;
      padding: 20px;
      width: 90%;
      height: 300px;
  }
  
  .services-container .carousel-container .carousel-item .image-container img {
      width: 100%;
      height: 100%;
      border-radius: 100px;
      background: #fff;
      overflow: hidden;
  }
  
  .services-container .carousel-container .carousel-item .description {
      font-size: 18px;
      color: #FFF;
      background-color: #262626;
      padding: 20px;
  }
  .service-desc {
  font-size: 18px;
  font-weight: 300;
}

@media (max-width: 600px) {
  .service-desc {
    font-size: 14px;
    font-weight: 300;
    line-height: 1.5;
  }
}
@media (min-width: 601px) and (max-width: 1000px) {
  .service-desc {
    font-size: 15px;
    font-weight: 300;
    line-height: 1.5;
  }
}
  
  @media only screen and (max-width: 1000px) {
    .services-container .service-item {
     flex-direction: column;
     height: auto;
    }
    .services-container .service-item .first {
      width: 90%;
      border-right: none;
      border-bottom: 2px solid #fff;
    }
    .services-container .service-item .second {
      width: 90%;
      border-right: none;
      /* border-bottom: 2px solid #fff; */
    }
    .services-container .service-item1 {
      display: flex;
      flex-direction: column;
      height: auto;
    }
    .services-container .service-item1 .first {
      width: 90%;
      border-right: none;
      border-bottom: 2px solid #fff;
    }
    .services-container .service-item1 .second {
      width: 90%;
      border-right: none;
      border-bottom: 2px solid #fff;
    }
    .services-container .printing-services-item {
      display: flex;
      flex-direction: column;
      height: auto;
      /* border-bottom: 2px solid #fff; */
  }

  .services-container .printing-services-item .first {
    width: 90%;
      border-right: none;
      border-bottom: 2px solid #fff;
      
  }
  
  .services-container .printing-services-item .second {
    width: 90%;
    border-right: none;
    /* border-bottom: 2px solid #fff; */
  }
  .services-container .main {
    width: 100%;
  }
  .services-container .section{
    width: 100%;
  }
     .services-container .service-item2 {
      flex-direction: column;
      height: auto;
    }
       .services-container .service-item2 .first{
     border-bottom: 2px solid #fff;
     width: 80%;
     border-right: none;
     border-top: none;
    }
    .services-container.service-item2.second{
      width: 80%;
    }
    .services-container .section .second {
      width: 80%;
    }
    .services-container .service-item1 .second{
      border-bottom: none;
    }
      .services-container .main-box {
display: flex;
flex-direction: column;
border: 1px solid #f6922f;
width: 80%;
padding: 10px !important;
text-align: left;
  }
    .services-container .main-box .inner-content{
display: flex;
align-items: flex-start !important;
font-size: 12px !important;
margin-top: 30px !important;
width: 100% !important;
  }
    .services-container .main-box .inner-content .image{
width: 50px;
height: 50px;
margin-right: 10px;
  }
    .services-container .main-box .title {
font-size: 20px !important;
margin-top:30px !important;
text-align: center;

 word-break: break-word;
  overflow-wrap: break-word;
  /* Optional: ensure it doesn't overflow its container */
  max-width: 100%;
  }
    .services-container .main-box .sub-title {
font-size:18px !important;
margin-bottom: 10px !important;
color: #f6922f; 
  }
  }
  /* === Carousel Dots Customization === */
.ant-carousel .slick-dots {
  bottom: 0; /* Adjust vertical positioning if needed */
}

.ant-carousel .slick-dots li {
  margin: 0 6px;
}

.ant-carousel .slick-dots li button {
  background-color: #888888; /* Inactive dot color */
  width: 10px;
  height: 10px;
  border-radius: 50%;
  opacity: 1; /* Ensures visible */
  transition: background-color 0.3s ease;
}

.ant-carousel .slick-dots li.slick-active button {
  background-color: #f7941d !important; /* Active dot color */
}

/* Desktop (default) */
.services-container .main-box {
  display: flex;
  flex-direction: column;
  border: 1px solid; /* Increase width for gradient visibility */
  border-image: linear-gradient(90deg, #f6922f, #e04c08) 1;
  width: 75%;
  padding: 30px;
  text-align: left;
  align-items: center;
  justify-content: center;
}

/* Tablet */
@media (max-width: 1000px) and (min-width: 601px) {
  .services-container .main-box {
    width: 95%;
    padding: 20px;
  }
}

/* Mobile */
@media (max-width: 600px) {
  .services-container .main-box {
    width: 100%;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/services/service.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,mEAAmE;EACnE,kBAAkB;EAClB,WAAW,GAAG,yCAAyC;AACzD;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,yDAA4D;EAC9D;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;AACF,eAAe;AACf,eAAe;AACf,kBAAkB;AAClB,kBAAkB;EAChB;CACD;EACC,eAAe;EACf,mBAAmB;EACnB,oDAAoD,EAAE,4BAA4B;EAClF,6BAA6B;EAC7B,oCAAoC;AACtC;EACE;AACF,aAAa;AACb,mBAAmB;AACnB,eAAe;AACf,gBAAgB;AAChB,gBAAgB;AAChB,WAAW;EACT;EACA;AACF,YAAY;AACZ,aAAa;AACb,kBAAkB;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,aAAa;IACb,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;EACf;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,uBAAuB;MACvB,gBAAgB;MAChB,aAAa;IACf;IACA;MACE,aAAa;MACb,aAAa;MACb,6BAA6B;IAC/B;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,uBAAuB;MACvB,gBAAgB;MAChB,4BAA4B;MAC5B,aAAa;IACf;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,uBAAuB;MACvB,gBAAgB;MAChB,aAAa;IACf;;IAEA;MACE,aAAa;MACb,aAAa;MACb,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,uBAAuB;MACvB,gBAAgB;MAChB,4BAA4B;MAC5B,aAAa;IACf;IACA;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,uBAAuB;MACvB,gBAAgB;MAChB,aAAa;IACf;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,2BAA2B;MAC3B,uBAAuB;MACvB,gBAAgB;MAChB,4BAA4B;MAC5B,aAAa;EACjB;;EAEA;MACI,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,uBAAuB;MACvB,gBAAgB;MAChB,aAAa;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;MACI,uBAAuB;MACvB,mBAAmB;MACnB,mBAAmB;MACnB,kBAAkB;MAClB,aAAa;MACb,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,kBAAkB;EACtB;;EAEA;MACI,aAAa;MACb,aAAa;MACb,mCAAmC;EACvC;EACA;IACE,eAAe;IACf,eAAe;IACf,cAAc;EAChB;EACA;MACI,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,2BAA2B;MAC3B,uBAAuB;MACvB,gBAAgB;MAChB,4BAA4B;MAC5B,aAAa;;EAEjB;;EAEA;MACI,aAAa;MACb,sBAAsB;MACtB,UAAU;MACV,uBAAuB;MACvB,gBAAgB;MAChB,aAAa;EACjB;;EAEA;MACI,gBAAgB;MAChB,mBAAmB;MACnB,UAAU;MACV,eAAe;EACnB;;EAEA;MACI,eAAe;MACf,WAAW;EACf;;EAEA;MACI,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,SAAS;MACT,eAAe;EACnB;;EAEA;MACI,eAAe;MACf,WAAW;MACX,yBAAyB;MACzB,aAAa;EACjB;;EAEA;MACI,aAAa;MACb,uBAAuB;MACvB,yBAAyB;MACzB,aAAa;MACb,UAAU;MACV,aAAa;EACjB;;EAEA;MACI,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,gBAAgB;MAChB,gBAAgB;EACpB;;EAEA;MACI,eAAe;MACf,WAAW;MACX,yBAAyB;MACzB,aAAa;EACjB;EACA;EACA,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;EAEE;IACE;KACC,sBAAsB;KACtB,YAAY;IACb;IACA;MACE,UAAU;MACV,kBAAkB;MAClB,6BAA6B;IAC/B;IACA;MACE,UAAU;MACV,kBAAkB;MAClB,mCAAmC;IACrC;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;IACd;IACA;MACE,UAAU;MACV,kBAAkB;MAClB,6BAA6B;IAC/B;IACA;MACE,UAAU;MACV,kBAAkB;MAClB,6BAA6B;IAC/B;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,mCAAmC;EACvC;;EAEA;IACE,UAAU;MACR,kBAAkB;MAClB,6BAA6B;;EAEjC;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,mCAAmC;EACrC;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;KACG;MACC,sBAAsB;MACtB,YAAY;IACd;OACG;KACF,6BAA6B;KAC7B,UAAU;KACV,kBAAkB;KAClB,gBAAgB;IACjB;IACA;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,mBAAmB;IACrB;MACE;AACN,aAAa;AACb,sBAAsB;AACtB,yBAAyB;AACzB,UAAU;AACV,wBAAwB;AACxB,gBAAgB;EACd;IACE;AACJ,aAAa;AACb,kCAAkC;AAClC,0BAA0B;AAC1B,2BAA2B;AAC3B,sBAAsB;EACpB;IACE;AACJ,WAAW;AACX,YAAY;AACZ,kBAAkB;EAChB;IACE;AACJ,0BAA0B;AAC1B,0BAA0B;AAC1B,kBAAkB;;CAEjB,sBAAsB;EACrB,yBAAyB;EACzB,uDAAuD;EACvD,eAAe;EACf;IACE;AACJ,yBAAyB;AACzB,8BAA8B;AAC9B,cAAc;EACZ;EACA;EACA,wCAAwC;AAC1C;EACE,SAAS,EAAE,0CAA0C;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU,EAAE,oBAAoB;EAChC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC,EAAE,qBAAqB;AAC7D;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,2CAA2C;EAC9D,wDAAwD;EACxD,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA,WAAW;AACX;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":["/* Services.css */\r\n.underline-gradient {\r\n  position: relative;\r\n  display: inline-block;\r\n  padding-bottom: 25px;\r\n}\r\n\r\n.underline-gradient::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  height: 1px;\r\n  background: linear-gradient(to right, white, rgba(246, 146, 47, 0));\r\n  border-radius: 1px;\r\n  width: 100%;  /* this now matches only the text width */\r\n}\r\n\r\n\r\n.services-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: #151515;\r\n    color: #FFF;\r\n    background-image: url(\"../../assets/images/always-grey.png\");\r\n  }\r\n  \r\n  .services-container .heading {\r\n    font-size: 40px;\r\n    font-weight: 500;\r\n    text-align: left;\r\n    width: 80%;\r\n    margin-top: 30px;\r\n  }\r\n  \r\n  .services-container .divider {\r\n    width: 80%;\r\n    border-bottom: 1px solid #575555;\r\n    text-align: center;\r\n    margin-bottom: 60px;\r\n  }\r\n\r\n  .services-container .main-box .title {\r\nfont-size: 30px;\r\nmargin-top:10px;\r\ntext-align: center;\r\nwidth: max-content;\r\n  }\r\n .services-container .main-box .sub-title {\r\n  font-size: 25px;\r\n  margin-bottom: 10px;\r\n  background: linear-gradient(90deg, #f6922f, #f44336); /* change colors as needed */\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n  .services-container .main-box .inner-content{\r\ndisplay: flex;\r\nalign-items: center;\r\nfont-size: 20px;\r\nmargin-top: 50px;\r\nline-height: 1.6;\r\nwidth: 100%;\r\n  }\r\n  .services-container .main-box .inner-content .image{\r\nwidth: 100px;\r\nheight: 100px;\r\nmargin-right: 30px;\r\n  }\r\n  .services-container .section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .services-container .section-title {\r\n    border: 2px solid white;\r\n    background: #262626;\r\n    margin-bottom: 50px;\r\n    width: fit-content;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .services-container .main {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  .services-container .service-item {\r\n    display: flex;\r\n    height: 315px;\r\n    border-bottom: 2px solid #fff;\r\n  }\r\n  .services-container .service-item .first {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 50%;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    text-align: left;\r\n    border-right: 2px solid #fff;\r\n    padding: 20px;\r\n  }\r\n\r\n  .services-container .service-item .title {\r\n      font-size: 30px;\r\n      font-weight: 600;\r\n      color: #f7941d;\r\n    }\r\n  \r\n    .services-container .service-item .second {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      padding: 20px;\r\n    }\r\n    .services-container .service-item1 {\r\n      display: flex;\r\n      height: 200px;\r\n      border-bottom: 2px solid #fff;\r\n    }\r\n    .services-container .service-item1 .first {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      border-right: 2px solid #fff;\r\n      padding: 20px;\r\n    }\r\n\r\n    .services-container .service-item1 .title {\r\n      font-size: 30px;\r\n      font-weight: 600;\r\n      color: #f7941d;\r\n    }\r\n  \r\n    .services-container .service-item1 .second {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      padding: 20px;\r\n    }\r\n    \r\n    .services-container .service-item2 {\r\n      display: flex;\r\n      height: 200px;\r\n      margin-bottom: 20px;\r\n    }\r\n    .services-container .service-item2 .first {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      border-right: 2px solid #fff;\r\n      padding: 20px;\r\n    }\r\n    .services-container .service-item2 .title {\r\n      font-size: 30px;\r\n      font-weight: 600;\r\n      color: #f7941d;\r\n    }\r\n  \r\n    .services-container .service-item2 .second {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      padding: 20px;\r\n    }\r\n    \r\n    .services-container .section .first {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      justify-content: flex-start;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      border-right: 2px solid #fff;\r\n      padding: 20px;\r\n  }\r\n  \r\n  .services-container .section .second {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      padding: 20px;\r\n  }\r\n  .services-container .printing-services-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n  }\r\n  .services-container .printing-services-title {\r\n      border: 2px solid white;\r\n      background: #262626;\r\n      margin-bottom: 50px;\r\n      width: fit-content;\r\n      padding: 10px;\r\n      border-radius: 8px;\r\n      font-size: 24px;\r\n      font-weight: 600;\r\n      text-align: center;\r\n  }\r\n  \r\n  .services-container .printing-services-item {\r\n      display: flex;\r\n      height: 300px;\r\n      /* border-bottom: 2px solid #fff; */\r\n  }\r\n  .services-container .printing-services-item .title {\r\n    font-size: 30px;\r\n    font-weight:600;\r\n    color: #f7941d;\r\n  }\r\n  .services-container .printing-services-item .first {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      justify-content: flex-start;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      border-right: 2px solid #fff;\r\n      padding: 20px;\r\n      \r\n  }\r\n  \r\n  .services-container .printing-services-item .second {\r\n      display: flex;\r\n      flex-direction: column;\r\n      width: 50%;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      padding: 20px;\r\n  }\r\n  \r\n  .services-container .carousel-container {\r\n      margin-top: 60px;\r\n      background: #151515;\r\n      width: 80%;\r\n      padding: 30px 0;\r\n  }\r\n  \r\n  .services-container .carousel-container .title {\r\n      font-size: 50px;\r\n      color: #FFF;\r\n  }\r\n  \r\n  .services-container .carousel-container .carousel-item {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      align-items: center;\r\n      gap: 20px;\r\n      background: red;\r\n  }\r\n  \r\n  .services-container .carousel-container .carousel-item .title {\r\n      font-size: 18px;\r\n      color: #FFF;\r\n      background-color: #262626;\r\n      padding: 20px;\r\n  }\r\n  \r\n  .services-container .carousel-container .carousel-item .image-container {\r\n      display: flex;\r\n      justify-content: center;\r\n      background-color: #262626;\r\n      padding: 20px;\r\n      width: 90%;\r\n      height: 300px;\r\n  }\r\n  \r\n  .services-container .carousel-container .carousel-item .image-container img {\r\n      width: 100%;\r\n      height: 100%;\r\n      border-radius: 100px;\r\n      background: #fff;\r\n      overflow: hidden;\r\n  }\r\n  \r\n  .services-container .carousel-container .carousel-item .description {\r\n      font-size: 18px;\r\n      color: #FFF;\r\n      background-color: #262626;\r\n      padding: 20px;\r\n  }\r\n  .service-desc {\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .service-desc {\r\n    font-size: 14px;\r\n    font-weight: 300;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n@media (min-width: 601px) and (max-width: 1000px) {\r\n  .service-desc {\r\n    font-size: 15px;\r\n    font-weight: 300;\r\n    line-height: 1.5;\r\n  }\r\n}\r\n  \r\n  @media only screen and (max-width: 1000px) {\r\n    .services-container .service-item {\r\n     flex-direction: column;\r\n     height: auto;\r\n    }\r\n    .services-container .service-item .first {\r\n      width: 90%;\r\n      border-right: none;\r\n      border-bottom: 2px solid #fff;\r\n    }\r\n    .services-container .service-item .second {\r\n      width: 90%;\r\n      border-right: none;\r\n      /* border-bottom: 2px solid #fff; */\r\n    }\r\n    .services-container .service-item1 {\r\n      display: flex;\r\n      flex-direction: column;\r\n      height: auto;\r\n    }\r\n    .services-container .service-item1 .first {\r\n      width: 90%;\r\n      border-right: none;\r\n      border-bottom: 2px solid #fff;\r\n    }\r\n    .services-container .service-item1 .second {\r\n      width: 90%;\r\n      border-right: none;\r\n      border-bottom: 2px solid #fff;\r\n    }\r\n    .services-container .printing-services-item {\r\n      display: flex;\r\n      flex-direction: column;\r\n      height: auto;\r\n      /* border-bottom: 2px solid #fff; */\r\n  }\r\n\r\n  .services-container .printing-services-item .first {\r\n    width: 90%;\r\n      border-right: none;\r\n      border-bottom: 2px solid #fff;\r\n      \r\n  }\r\n  \r\n  .services-container .printing-services-item .second {\r\n    width: 90%;\r\n    border-right: none;\r\n    /* border-bottom: 2px solid #fff; */\r\n  }\r\n  .services-container .main {\r\n    width: 100%;\r\n  }\r\n  .services-container .section{\r\n    width: 100%;\r\n  }\r\n     .services-container .service-item2 {\r\n      flex-direction: column;\r\n      height: auto;\r\n    }\r\n       .services-container .service-item2 .first{\r\n     border-bottom: 2px solid #fff;\r\n     width: 80%;\r\n     border-right: none;\r\n     border-top: none;\r\n    }\r\n    .services-container.service-item2.second{\r\n      width: 80%;\r\n    }\r\n    .services-container .section .second {\r\n      width: 80%;\r\n    }\r\n    .services-container .service-item1 .second{\r\n      border-bottom: none;\r\n    }\r\n      .services-container .main-box {\r\ndisplay: flex;\r\nflex-direction: column;\r\nborder: 1px solid #f6922f;\r\nwidth: 80%;\r\npadding: 10px !important;\r\ntext-align: left;\r\n  }\r\n    .services-container .main-box .inner-content{\r\ndisplay: flex;\r\nalign-items: flex-start !important;\r\nfont-size: 12px !important;\r\nmargin-top: 30px !important;\r\nwidth: 100% !important;\r\n  }\r\n    .services-container .main-box .inner-content .image{\r\nwidth: 50px;\r\nheight: 50px;\r\nmargin-right: 10px;\r\n  }\r\n    .services-container .main-box .title {\r\nfont-size: 20px !important;\r\nmargin-top:30px !important;\r\ntext-align: center;\r\n\r\n word-break: break-word;\r\n  overflow-wrap: break-word;\r\n  /* Optional: ensure it doesn't overflow its container */\r\n  max-width: 100%;\r\n  }\r\n    .services-container .main-box .sub-title {\r\nfont-size:18px !important;\r\nmargin-bottom: 10px !important;\r\ncolor: #f6922f; \r\n  }\r\n  }\r\n  /* === Carousel Dots Customization === */\r\n.ant-carousel .slick-dots {\r\n  bottom: 0; /* Adjust vertical positioning if needed */\r\n}\r\n\r\n.ant-carousel .slick-dots li {\r\n  margin: 0 6px;\r\n}\r\n\r\n.ant-carousel .slick-dots li button {\r\n  background-color: #888888; /* Inactive dot color */\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  opacity: 1; /* Ensures visible */\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.ant-carousel .slick-dots li.slick-active button {\r\n  background-color: #f7941d !important; /* Active dot color */\r\n}\r\n\r\n/* Desktop (default) */\r\n.services-container .main-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid; /* Increase width for gradient visibility */\r\n  border-image: linear-gradient(90deg, #f6922f, #e04c08) 1;\r\n  width: 75%;\r\n  padding: 30px;\r\n  text-align: left;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Tablet */\r\n@media (max-width: 1000px) and (min-width: 601px) {\r\n  .services-container .main-box {\r\n    width: 95%;\r\n    padding: 20px;\r\n  }\r\n}\r\n\r\n/* Mobile */\r\n@media (max-width: 600px) {\r\n  .services-container .main-box {\r\n    width: 100%;\r\n    padding: 10px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
